import React, { useState, useEffect} from "react";
import { Box, Button, Paper } from "@mui/material";
import {useSelector} from "react-redux"
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import api from "../../../API";
import AddPartnerDialog from "./AddPartnerDialog"

const NKIWorkerListPage = (props:any) => {

  const [partnerList, setPartnerList] = useState([]);
  const [setPartnerCount, setScriptCount] = useState(0);

  const [subPartnerId, setSubPartnerId] = useState("");
  const [subPartnerName, setSubPartnerName] = useState("");

  const [addPartnerDialog, setAddPartnerDialog] = useState<boolean>(false);

  const userInfo = useSelector((state:any)=> state.userInfo.data.user)

  // console.log('유저 정보')
  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const getPartnerList = async () => {
    api.get('/getPartnerList',{params:{email:email}})
    .then((res:any) => {
      // console.log("파트너 리스트 ", res.data.datas); 
      setPartnerList(res.data.datas); 
      setScriptCount(res.data.datas.length) 
    })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {alert("파일 업로드 실패. " + error.response.data.error); console.error('에러',error.response);})
    
  }

  useEffect(()=>{
    getPartnerList()
  },[])
  
  return (
    <Paper sx={{borderTop: "4px solid #3e36a5", width:"846px", height:"256px", overflow: "auto"}}>
      <Box>
        {addPartnerDialog ? <AddPartnerDialog setAddPartnerDialog={setAddPartnerDialog} getPartnerList={getPartnerList} /> : <></>}
      </Box>
      <Box sx={{display:"flex"}}>
          <Box sx={{padding:"30px"}}>
            <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px", display:"flex", alignItems:"center"}}>
            <Box sx={{fontWeight:700}}>
              참석자 2 : {subPartnerId ? <b style={{color:"#03cf5d"}}> {subPartnerName}({subPartnerId})</b> : <b style={{color:"#ff0000"}}> 연결안됨</b>}
            </Box>
            </Box>
            {/* <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>연결화자 목록</Box> */}
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <Box sx={{display:"flex", alignItems:"center"}}>
              <Box sx={{fontWeight:700}}>연결화자 목록</Box>
              <Button variant="contained" sx={{color:"blue", border:"2px solid blue",height:"30px",":hover":{backgroundColor:"blue" , color:"#fff"} , backgroundColor:"#fff",display:"flex", marginLeft:"auto", marginRight:"20px"}} onClick={()=> setAddPartnerDialog(true)}>+ 화자추가</Button>
            </Box>
            <TableContainer sx={{maxHeight:"440px",fontSize:"12px"}}>
              <Table sx={{ minWidth: 500 }} size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>이름</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>나이대</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>성별</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>화자ID</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>구분</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}></Box></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {partnerList.map((partner:any,idx:number) => (
                    (partner.main_yn=='Y' ? 
                    <TableRow key={(idx+1)+"_main"}>
                      <TableCell component="th" scope="row" align="center"><b style={{color:"#f1a425"}}>★</b>{partner.name}</TableCell>
                      <TableCell align="center">{partner.agegroup === "50" ? "50이상": partner.agegroup}</TableCell>
                      <TableCell align="center">{partner.gender}</TableCell>
                      <TableCell align="center">{partner.id}</TableCell>
                      <TableCell align="center">참석자 1</TableCell>
                      <TableCell align="center">-</TableCell>
                    </TableRow>
                    :
                    <TableRow key={(idx+1)+"_sub"} sx={{backgroundColor:(subPartnerName == partner.name ? "#baf3d3" : "#fff")}}>
                      <TableCell component="th" scope="row" align="center">{partner.name}</TableCell>
                      <TableCell align="center">{partner.agegroup === "50" ? "50이상": partner.agegroup}</TableCell>
                      <TableCell align="center">{partner.gender}</TableCell>
                      <TableCell align="center">{partner.id}</TableCell>
                      <TableCell align="center">참석자 2</TableCell>
                      <TableCell align="center">
                        <Button variant="contained" sx={{color:(subPartnerName === partner.name ? "#fff":"#03cf5d"), border:"2px solid #03cf5d",height:"30px",
                        ":hover":{backgroundColor:"#03cf5d", color:"#fff"} , backgroundColor:(subPartnerName === partner.name ? "#03cf5d":"#fff"), display:"flex", marginLeft:"auto"}} 
                        onClick={()=> {alert(partner.name+"("+partner.id+") 화자 연결이 완료되었습니다."); props.setSpeaker2(partner.id); setSubPartnerId(partner.id); setSubPartnerName(partner.name);}}>{subPartnerName === partner.name ? "연결됨":"연결"}</Button>
                      </TableCell>
                    </TableRow>
                    )
                    
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
    </Paper>
  );
};

export default NKIWorkerListPage;
